module.exports = __webpack_public_path__ + "static/img/WH-1000XM3.b534d27c.jpg";